<template>
    <div>
        <a-pricing-slider :disabled="false" :showIcon="false" class="calculator" />
    </div>
</template>
<script>
import APricingSlider from "@/components/Slider/APricingSlider";

export default {
    components: {
        APricingSlider
    }
}
</script>

<style lang="css">
.ant-alert-success {
    background-color: #eef4ff;
    border: 2px solid #eef4ff;
}
</style>